module.exports = {
  firstOrder: "01",
  colorGreen: "green",
  transitionTime: 500,
  defaultTransitionTime: 1,
}
